/**
 * Minimal `URL`-stub for server side rendering (SSR).
 *
 * ClearScript V8 (ReactJS.NET) har ikke `URL`. react-router@8 (via @helsenorge/core-cms) kjører
 * `new URL("http://localhost")` når modulen lastes. Uten stub feiler lasting av helsenorge.js med «URL is not defined».
 *
 * Kun lesing av href, origin, protocol, host, hostname, port, pathname, search og hash. Ingen validering,
 * ingen koding, ingen `searchParams`. No-op der `URL` finnes fra før (nettleser, Node).
 *
 * @todo Fjern når #387076 er løst (core-cms skal ikke importere react-router i komponenter som rendres på server).
 */

const URL_REGEX = /^(?:([a-z][\w+.-]*:)\/\/([^/?#]*))?([^?#]*)(\?[^#]*)?(#.*)?$/i;

type UrlInput = string | { toString(): string };

class UrlStub {
  readonly protocol: string;
  readonly host: string;
  readonly hostname: string;
  readonly port: string;
  readonly origin: string;
  readonly pathname: string;
  readonly search: string;
  readonly hash: string;
  readonly href: string;

  constructor(url: UrlInput, base?: UrlInput) {
    const [, protocol = '', host = '', pathname = '', search = '', hash = ''] = URL_REGEX.exec(String(url)) ?? [];
    const [, baseProtocol = '', baseHost = ''] = (!protocol && base !== undefined && URL_REGEX.exec(String(base))) || [];

    this.protocol = protocol || baseProtocol;
    this.host = host || baseHost;
    const [hostname = '', port = ''] = this.host.split(':');
    this.hostname = hostname;
    this.port = port;
    this.origin = this.protocol ? `${this.protocol}//${this.host}` : 'null';
    this.pathname = pathname || '/';
    this.search = search;
    this.hash = hash;
    this.href = (this.protocol ? this.origin : '') + this.pathname + search + hash;
  }

  toString(): string {
    return this.href;
  }

  toJSON(): string {
    return this.href;
  }
}

const globalObject = globalThis as unknown as Record<string, unknown>;

if (typeof globalObject.URL === 'undefined') {
  globalObject.URL = UrlStub;
}

export {};
